type HeldGuest = {
  firstName?: string;
  lastName?: string;
  externalSpaId?: number | string | null;
};

export type HeldSpaTime = {
  guest: HeldGuest;
  date: string;
  startTime: string;
};

type BasketSelection = {
  startTime?: string | null;
  startDate?: string | null;
  guestDetails?: HeldGuest;
};
type BasketSelectionGroup = { isExtras?: boolean; selections?: unknown };
type BasketItem = { checkIn?: string | null; selectionGroups?: unknown };

const asArray = <T>(value: unknown): (T | null | undefined)[] =>
  Array.isArray(value) ? value : [];

const toHoursAndMinutes = (time: string) => time.slice(0, 5);

export const heldSpaTimesFromBasket = (items: unknown): HeldSpaTime[] =>
  asArray<BasketItem>(items).flatMap((item) =>
    asArray<BasketSelectionGroup>(item?.selectionGroups)
      .filter((group) => !!group && !group.isExtras)
      .flatMap((group) => asArray<BasketSelection>(group?.selections))
      .flatMap((selection) => {
        const date = selection?.startDate ?? item?.checkIn;
        const guest = selection?.guestDetails;
        if (!selection?.startTime || !date || !guest?.firstName) return [];

        return [
          {
            guest,
            date: date.slice(0, 10),
            startTime: toHoursAndMinutes(selection.startTime),
          },
        ];
      })
  );

const normalisedName = (name?: string) => name?.trim().toLowerCase() ?? '';

const isSameGuest = (guest: HeldGuest, held: HeldGuest) => {
  if (held.externalSpaId && guest.externalSpaId) {
    return String(held.externalSpaId) === String(guest.externalSpaId);
  }

  const firstName = normalisedName(held.firstName);
  return (
    !!firstName &&
    firstName === normalisedName(guest.firstName) &&
    normalisedName(held.lastName) === normalisedName(guest.lastName)
  );
};

export const heldStartTimesFor = (
  heldSpaTimes: HeldSpaTime[],
  guests: HeldGuest[],
  date: string
): string[] =>
  heldSpaTimes
    .filter((held) => held.date === date && guests.some((guest) => isSameGuest(guest, held.guest)))
    .map((held) => held.startTime);
